<template>
  <div>
    <div class="white-wrapper">
      <!-- <form> -->
      <div class="row">
        <div class="col-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : '' ">Select Cinema</label>
              <b-dropdown :text="selectedCinema" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  href="#"
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>

            <Tooltip :title="$t('chargeSettings_selectCinema')" />
          </div>
        </div>

        <div class="col-6 mb-4">
          <div class="d-flex justify-content-center align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="cinemaChargesSettings.pas_charge_setting_name"
                required
              />
              <label>{{ $t('chargesettingname') }}</label>
            </div>

            <Tooltip :title="$t('chargeSettings_ChargeSettingsName')" />
          </div>
        </div>

        <div
          class="col-12 mb-4"
          v-for="(cinemaChargesSetting, cinemaChargesSettingIndex) in cinemaChargesSettingList"
          :key="cinemaChargesSettingIndex"
        >
          <div class="row border mx-0 rounded-10 py-3">
            <div class="col-11">
              <div class="row">
                <div class="col-6 align-self-center">
                  <div class="row">
                    <div class="col-12 mb-4">
                      <div class="dropdown-rve-container">
                        <label
                          :class="cinemaChargesSetting.selectedChargeType.length > 0 ? 'shift-up' : '' "
                        >Charge Types</label>
                        <div class="d-flex justify-content-center align-items-center">
                          <b-dropdown
                            :text="cinemaChargesSetting.selectedChargeType"
                            variant="dropdown-curve"
                            class="w-100"
                          >
                            <b-dropdown-item
                              v-for="(CinemasChargeType, CinemasChargeTypeIndex) in CinemasChargeType"
                              :key="CinemasChargeTypeIndex"
                              v-on:click="onSelectChargeTypes($event, CinemasChargeType, cinemaChargesSettingIndex)"
                            >{{ CinemasChargeType.ct_name }}</b-dropdown-item>
                          </b-dropdown>
                          <Tooltip :title="$t('chargeSettings_ChargeTypes')" />
                        </div>
                      </div>
                    </div>

                    <div class="col-6 mb-4">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <div class="add-datepicker">
                            <Datepicker :monday-first="true"
                              v-model="cinemaChargesSetting.pas_start_date"
                              ref="programaticOpen"
                            ></Datepicker>
                            <label
                              :class="cinemaChargesSetting.pas_start_date ? 'active': ''"
                            >{{ $t('fromdate') }}</label>
                          </div>
                        </div>

                        <Tooltip :title="$t('chargeSettings_FromDate')" />
                      </div>
                      <p class="error_msg">{{ $t('blankfieldmsg')}}</p>
                    </div>

                    <div class="col-6 mb-4">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <div class="add-datepicker">
                            <Datepicker :monday-first="true"
                              v-model="cinemaChargesSetting.pas_end_date"
                              ref="programaticOpen"
                            ></Datepicker>
                            <label
                              :class="cinemaChargesSetting.pas_end_date ? 'active': ''"
                            >{{ $t('todate') }}</label>
                          </div>
                        </div>

                        <Tooltip :title="$t('chargeSettings_ToDate')" />
                      </div>
                      <p class="error_msg">{{ $t('blankfieldmsg')}}</p>
                    </div>

                    <div class="col-12">
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="input-material">
                          <input
                            type="number"
                            step="any"
                            v-model="cinemaChargesSetting.pas_charge_value"
                            required
                          />
                          <label>{{ $t('chargevalue') }}</label>
                        </div>
                        <Tooltip :title="$t('chargeSetting_chargeValue')" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="col-12 mb-3">
                    <div class="row">
                      <div class="col-8">
                        <label>{{ $t('isPercentage') }}</label>
                      </div>
                      <div class="col-4">
                        <b-form-checkbox
                          v-model="cinemaChargesSetting.pas_is_percentage"
                          unchecked-value="N"
                          value="Y"
                          name="check-button"
                          switch
                        ></b-form-checkbox>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mb-3">
                    <div class="row">
                      <div class="col-8">
                        <label>{{ $t('isdeduction') }}</label>
                      </div>
                      <div class="col-4">
                        <b-form-checkbox
                          v-model="cinemaChargesSetting.pas_is_deduction"
                          unchecked-value="N"
                          value="Y"
                          name="check-button"
                          switch
                        ></b-form-checkbox>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mb-3">
                    <div class="row">
                      <div class="col-8">
                        <label>{{ $t('taxable') }}</label>
                      </div>
                      <div class="col-4">
                        <b-form-checkbox
                          v-model="cinemaChargesSetting.pas_is_taxable"
                          unchecked-value="N"
                          value="Y"
                          name="check-button"
                          switch
                        ></b-form-checkbox>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mb-3">
                    <div class="row">
                      <div class="col-8">
                        <label>{{ $t('sharewithdistributor') }}</label>
                      </div>
                      <div class="col-4">
                        <b-form-checkbox
                          unchecked-value="N"
                          v-model="cinemaChargesSetting.pas_is_shareable_with_distributor"
                          value="Y"
                          name="check-button"
                          switch
                        ></b-form-checkbox>
                      </div>
                    </div>
                  </div>

                  <div class="col-12" v-if="false">
                    <div class="row">
                      <div class="col-8">
                        <label>{{ $t('overandabove') }}</label>
                      </div>
                      <div class="col-4">
                        <b-form-checkbox
                          unchecked-value="N"
                          v-model="cinemaChargesSetting.pas_is_overnabove"
                          value="Y"
                          name="check-button"
                          switch
                        ></b-form-checkbox>
                      </div>
                    </div>
                  </div>
                
                  <div class="col-12">
                    <div class="row">
                      <div class="col-8">
                        <label>{{ $t('On Gross Amount') }}</label>
                      </div>
                      <div class="col-4">
                        <b-form-checkbox
                          unchecked-value="N"
                          v-model="cinemaChargesSetting.pas_is_on_gross_amount"
                          value="Y"
                          name="check-button"
                          switch
                        ></b-form-checkbox>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-1 d-flex justify-content-center align-items-center border-left">
              <button
                v-if="cinemaChargesSettingIndex === 0"
                v-on:click="increaseCinemaChargesSetting()"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
              <button
                v-else
                @click="decreaseCinemaChargesSetting(cinemaChargesSettingIndex)"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 text-center">
        <button @click.prevent.stop="goBack()" class="btn-blue">{{ $t('Back') }}</button>
        <button @click.prevent.stop="onFinalSubmit(false)" class="btn-blue">{{ $t('Next') }}</button>
      </div>
    </div>
    <!-- </form> -->
  </div>
</template>

<script>
import DistributorService from "@/services/DistributorService";
import CinemasService from "@/services/CinemasService";
import MovieService from "@/services/MovieService";

export default {
  data() {
    return {
      // Saif
      Cinemas: [],
      CinemasChargeType: [],
      selectedChargeType: "",
      selectedCinema: "",

      cinemaChargesSettings: {
        pas_charge_setting_name: "",
        cinema_id: null,
        created_at: "",
        created_by: "",
        updated_by: "",
        updated_at: ""
      },
      cinemaChargesSettingList: [
        {
          pas_id: null,

          selectedChargeType: "",
          charge_type_id: null,
          pas_start_date: null,
          pas_end_date: null,
          pas_charge_value: 0,
          pas_is_percentage: "Y",
          pas_is_deduction: "Y",
          pas_is_taxable: "Y",
          pas_is_shareable_with_distributor: "Y",
          pas_is_overnabove: "Y",
          pas_is_on_gross_amount:"Y",
          pas_is_active: "Y",
          created_at: "",
          created_by: "",
          updated_by: "",
          updated_at: ""
        }
      ],

      // Saif
      validate: false
    };
  },
  computed: {
    validStatus() {
      return this.validate ? true : false;
    }
  },
  beforeMount() {
    this.getCinemaList();
    this.getChargeTypeList();
  },
  mounted() {},

  methods: {
    // Saif
    getCinemaList: function() {
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            console.log("this.Cinemas :", this.Cinemas);
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getChargeTypeList: function() {
      CinemasService.GetActiveCinemasChargeType({ activekey: "ct_is_active" })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasChargeType = data.Records;
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    onSelectCinema: function(event, params) {
      this.selectedCinema = params.cine_name;
      this.cinemaChargesSettings.cinema_id = params.cine_id;
    },
    onFinalSubmit: function() {
      let payload = {
        ...this.cinemaChargesSettings,
        CinemaChargesSettingList: this.cinemaChargesSettingList
      };
      console.log("payload :", payload);
      CinemasService.AddCinemaCharges(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.onResetForm();
            this.$router.push({
              path: "price-master"
            });
          } else {
            // Show Error Message
            console.log("data.message :", data.message || "");
          }
        })
        .catch(error => {
          // Catch Error
          console.log("Catch error on AddCinemaCharges :", error);
        });
    },
    onResetForm: function() {
      this.selectedChargeType = "";
      this.selectedCinema = "";
      this.cinemaChargesSettings = {
        pas_id: null,
        cinema_id: null,
        created_at: "",
        created_by: "",
        updated_by: "",
        updated_at: ""
      };
      this.cinemaChargesSettingList = [
        {
          selectedChargeType: "",
          charge_type_id: null,
          pas_start_date: null,
          pas_end_date: null,
          pas_charge_value: 0,
          pas_is_percentage: "Y",
          pas_is_deduction: "Y",
          pas_is_taxable: "Y",
          pas_is_shareable_with_distributor: "Y",
          pas_is_overnabove: "Y",
          pas_is_on_gross_amount:"Y",
          pas_is_active: "Y",
          created_at: "",
          created_by: "",
          updated_by: "",
          updated_at: ""
        }
      ];
    },
    goBack: function() {
      this.$router.push({
        path: "add-seat-layout"
      });
    },
    onSelectChargeTypes: function(event, params, cinemaChargesSettingIndex) {
      this.cinemaChargesSettingList[
        cinemaChargesSettingIndex
      ].selectedChargeType = params.ct_name;
      this.cinemaChargesSettingList[cinemaChargesSettingIndex].charge_type_id =
        params.ct_id;
    },
    increaseCinemaChargesSetting: function() {
      this.cinemaChargesSettingList.push({
        pas_id: null,
        selectedChargeType: "",
        charge_type_id: null,
        pas_start_date: null,
        pas_end_date: null,
        pas_charge_value: 0,
        pas_is_percentage: "Y",
        pas_is_deduction: "Y",
        pas_is_taxable: "Y",
        pas_is_shareable_with_distributor: "Y",
        pas_is_overnabove: "Y",
        pas_is_on_gross_amount: "Y",
        pas_is_active: "Y",
        created_at: "",
        created_by: "",
        updated_by: "",
        updated_at: ""
      });
    },
    decreaseCinemaChargesSetting: function(index) {
      this.cinemaChargesSettingList.splice(index, 1);
    }
    // Saif
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Installation/chargeSettings.vue